import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import AiSensyPaymentPage from "./pages/PaymentPages/PaymentPage.js";
import ThankYouPage from "./pages/PaymentPages/ThankYouPage.js";
import RegionalPlansPage from "./pages/PlanPages/RegionalPlansPage.js";
import PlanThankYouPage from "./pages/PlanPages/ThankYouPage.js";
import OfferCheckoutPage from "./pages/OfferCheckout/OfferCheckoutPage.js";
import ShippingPage from "./pages/OfferCheckout/ShippingPage.js";
import AdsCheckoutPage from "./pages/PlanPages/AdsCheckoutPage.js";
import WebinarCheckoutPage from "./pages/WebinarCheckout/WebinarCheckoutPage.js";
import CheckoutPageContainer from "./pages/CheckoutPage/CheckoutPageContainer.js";

const App = (props) => {
  return (
    <BrowserRouter>
      <Switch>
        {/* Single-page checkout — the two-step plans checkout collapsed into
            one page. Config comes from integrations-server (region "offers");
            adding a page is config-only, no deploy here.

            `/checkout/:slug` is the canonical prefix. `/offer/:slug` is kept
            as a permanent alias because live ads, emails and access-code
            links already point at it — never remove it. */}
        <Route exact path="/checkout/:offerSlug" component={OfferCheckoutPage} />
        <Route exact path="/offer/:offerSlug" component={OfferCheckoutPage} />

        {/* Sales mirror (INT-56) — same pages, same slugs, same config as the
            /checkout and /offer routes above, but for salesperson-shared links.
            The ONLY difference is "sales mode": every client-side marketing
            tracker is suppressed (see isSalesRoute + index.html gate), and the
            backend keeps only LeadSquared (no WhatsApp/Slack/Pabbly/cart
            recovery), stamping analytics isSales so they never hit the founder
            dashboard. No config duplication — the slug is unchanged. */}
        <Route
          exact
          path="/sales/checkout/:offerSlug"
          component={OfferCheckoutPage}
        />
        <Route
          exact
          path="/sales/offer/:offerSlug"
          component={OfferCheckoutPage}
        />

        {/* Post-payment shipping capture — URL carries only the customer's DB _id */}
        <Route
          exact
          path="/offer/:offerSlug/shipping/:customerId"
          component={ShippingPage}
        />
        <Route
          exact
          path="/sales/offer/:offerSlug/shipping/:customerId"
          component={ShippingPage}
        />


        <Route exact path="/ads/:adSlug" component={AdsCheckoutPage} />

        {/* Webinar checkout — single-page, fully backend-config-driven */}
        <Route
          exact
          path="/webinar/:webinarSlug"
          component={WebinarCheckoutPage}
        />

        {/* Affiliate checkout-builder pages. Prefixed with /pay so they are not
            swallowed by the /:eventSlug catch-all further down. */}
        <Route exact path="/pay/:pageId" component={CheckoutPageContainer} />

        {/* Regional plans routes - must come first */}

        <Route exact path="/whitelabel-partner">
          <Redirect to="/whitelabel-partner-plans-1" />
        </Route>
        
        <Route
          exact
          path="/:region-plans-:version"
          component={RegionalPlansPage}
        />
        <Route exact path="/thankyou-:region" component={PlanThankYouPage} />

        {/* Dynamic event routes */}
        <Route exact path="/:eventSlug/thankyou" component={ThankYouPage} />
        <Route exact path="/:eventSlug" component={AiSensyPaymentPage} />

        {/* Legacy routes for backward compatibility */}
        <Route exact path="/evolve" component={AiSensyPaymentPage} />
        <Route exact path="/thankyou" component={ThankYouPage} />
      </Switch>
    </BrowserRouter>
  );
};

export default connect((state) => ({
  isAuthenticated: state.login.isAuthenticated,
}))(App);
